export default __webpack_public_path__ + "static/char-v-38-c59229f7b068a6228f2b9a3feb64ab48.webp";